const driverLicenseStatusFilters = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};

export default driverLicenseStatusFilters;
